<template>
	<div>
		<div class="d-flex align-items-center mb-2">
			<span class="fw-semibold">{{ count }} {{ label }} selected</span>
			<button
				class="btn btn-sm btn-outline-secondary ms-auto"
				@click="emit('clear')"
			>
				Clear
			</button>
		</div>

		<div v-if="kind === 'signal'" class="row g-2 mb-2">
			<div class="col-6">
				<label class="form-label small mb-1">Provenance class</label>
				<select v-model="classValue" class="form-select form-select-sm">
					<option value="" disabled>Class…</option>
					<option
						v-for="value in provenanceClasses"
						:key="value"
						:value="value"
					>
						{{ value }}
					</option>
				</select>
			</div>
			<div class="col-6">
				<label class="form-label small mb-1">Effect</label>
				<select v-model="effectValue" class="form-select form-select-sm">
					<option value="" disabled>Effect…</option>
					<option v-for="value in effects" :key="value" :value="value">
						{{ value }}
					</option>
				</select>
			</div>
			<div class="col-12">
				<button
					class="btn btn-sm btn-outline-primary"
					:disabled="saving || !classValue || !effectValue"
					@click="bulkReview"
				>
					Review selected
				</button>
			</div>
			<div class="col-12">
				<button class="btn btn-sm btn-success w-100" @click="emit('forge')">
					Forge Lead from selected
				</button>
			</div>
		</div>

		<div v-else-if="kind === 'work_order'">
			<p class="small text-muted">
				Cancelling selected Work Orders requires one reason for the set.
			</p>
			<button
				class="btn btn-sm btn-outline-danger"
				:disabled="saving"
				@click="cancelSelected"
			>
				Cancel selected…
			</button>
		</div>

		<div v-else class="small text-muted">
			Choose one Lead to edit it. Bulk Lead actions are not part of this pass.
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

const props = defineProps<{
	kind: string;
	count: number;
	saving: boolean;
}>();
const emit = defineEmits<{
	(e: "review", body: { provenance_class: string; effect: string }): void;
	(e: "forge"): void;
	(e: "cancel", reason: string): void;
	(e: "clear"): void;
}>();

const provenanceClasses = [
	"production",
	"nuisance",
	"environmental",
	"administrative",
];
const effects = ["promotive", "suppressive", "contextual"];
const classValue = ref("");
const effectValue = ref("");

const label = computed(() =>
	props.kind === "signal"
		? "signals"
		: props.kind === "work_order"
			? "Work Orders"
			: "Leads",
);

function bulkReview() {
	emit("review", {
		provenance_class: classValue.value,
		effect: effectValue.value,
	});
}

function cancelSelected() {
	const reason = window.prompt(
		"Reason for cancelling the selected Work Orders",
	);
	if (reason && reason.trim()) emit("cancel", reason.trim());
}
</script>
